import KmInput from './main.vue'
KmInput.install = function (vue) {
  vue.component(KmInput.name, KmInput)
}
export default KmInput



// WEBPACK FOOTER //
// ./src/ui/components/km-input/index.js